import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Button } from "semantic-ui-react";
import {
  createAspekAdministrasi,
  findAspekAdministrasiByYearAndMonthAndPerusahaanId,
  updateAspekAdministrasi,
} from "../../api";
import { MenuMonth } from "../../component/Utils";
import FormField from "./components/FormField";
import HeaderComp from "./components/HeaderComp";

const AspekAdministrasi = () => {
  const filter = useSelector((state) => state.main);
  const year = useSelector((state) => state.main.yearFilter);
  const month = useSelector((state) => state.main.monFilter);
  const perusahaan = useSelector((state) => state.main.perusahaanFilter);
  const [id, setId] = useState(null);
  const [laporanPerhitunganTahunan, setLaporanPerhitunganTahunan] = useState(null);
  const [rancanganRkap, setRancanganRkap] = useState(null);
  const [laporanPeriodik, setLaporanPeriodik] = useState(null);
  const [tanggungJawabSosial, setTanggungJawabSosial] = useState(null);
  const [pajak, setPajak] = useState(null);
  const fields = [
    {
      label: "Laporan Perhitungan Tahunan",
      value: laporanPerhitunganTahunan,
      onChange: (value) => setLaporanPerhitunganTahunan(value),
      description:
        "Standar waktu penyampaian perhitungan tahunan yang telah diaudit oleh akuntan publik harus sudah diterima oleh Pemegang paling lambat akhir bulan ke empat sejak tanggal tutup buku tahun yang bersangkutan",
    },
    {
      label: "Rancangan RKAP",
      value: rancanganRkap,
      onChange: (value) => setRancanganRkap(value),
      description:
        "Sesuai ketentuan Pasal 16 ayat 1 Permendagri No. 118 Tahun 2018, Rancangan RKA paling lambat disampaikan akhir bulan Nopember sebelum tahun RKA BUMD dimulai",
    },
    {
      label: "Laporan Periodik",
      value: laporanPeriodik,
      onChange: (value) => setLaporanPeriodik(value),
      description:
        "Laporan periodik Triwulanan harus diterima oleh Komisaris Dewan Pengawas dan Pemegang Saham paling lambat 1 (satu) bulan setelah berakhirnya periode laporan",
    },
    {
      label: "CSR",
      value: tanggungJawabSosial,
      onChange: (value) => setTanggungJawabSosial(value),
      description: "Partisipasi BUMD dalam penyaluran CSR",
    },
    {
      label: "Pajak atau GCG",
      value: pajak,
      onChange: (value) => setPajak(value),
      description: "Kontribusi Pajak GCG dari BUMD pada tahun berkenaan",
    },
  ];

  const handleSubmit = async () => {
    try {
      let data = {
        laporanPerhitunganTahunan,
        rancanganRkap,
        laporanPeriodik,
        tanggungJawabSosial,
        pajak,
        year,
        month,
        perusahaan: {
          id: perusahaan,
        },
      };
      if (id) {
        data.id = id;
        await updateAspekAdministrasi(data);
        toast.info("Data Berhasil Diubah");
      } else {
        await createAspekAdministrasi(data);
        toast.success("Data Berhasil Disimpan");
      }

    } catch (err) {}
  };

  const loadData = async (year, month, perusahaanId) => {
    try {
      if (year &&  perusahaanId) {
        const res = await findAspekAdministrasiByYearAndMonthAndPerusahaanId({ year, month, perusahaanId });
        if (res.data.length > 0) {
          const data = res.data[0];
          setId(data.id);
          setLaporanPerhitunganTahunan(data.laporanPerhitunganTahunan);
          setRancanganRkap(data.rancanganRkap);
          setLaporanPeriodik(data.laporanPeriodik);
          setTanggungJawabSosial(data.tanggungJawabSosial);
          setPajak(data.pajak);
        } else {
          setId(null);
          setLaporanPerhitunganTahunan(null);
          setRancanganRkap(null);
          setLaporanPeriodik(null);
          setTanggungJawabSosial(null);
          setPajak(null);
        }
      }
    } catch (err) {}
  };

  useEffect(() => {
    loadData(year, month, perusahaan);
  }, [year, month, perusahaan]);

  return (
    <>
      <HeaderComp title="Aspek Adminstrasi" />
      <div className="container mt-3">
        <div className="card container shadow-sm border-0">
          <div className="row">
            <div className="col-md-4 py-3 border-right">
              <MenuMonth pathUrl="aspek-administrasi" keterangan={false} />
            </div>
            <div className="col-md-8 py-3">
              <h3>
                Aspek Adminstrasi - {filter.labelMonth} {year}
              </h3>
              <hr />
              {fields.map((field, key) => (
                <FormField
                  type="radio"
                  label={field.label}
                  key={key}
                  value={field.value}
                  onChange={field.onChange}
                  description={field.description}
                />
              ))}
              <hr />
              <Button color="blue" onClick={handleSubmit}>
                Simpan
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AspekAdministrasi;
